export const EMPLOYER_REP_ROLES = {
    HR: 'HR',
    NON_HR: 'NON_HR',
    ADMIN: 'EM_REP_ADMIN',
    USER: 'EM_REP_USER',
    HIRING_MANAGER: 'HIRING_MANAGER',
    SALES: 'SALES',
};

export const EMPLOYER_REP_STATUSES = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    INVITED: 'invited',
    PENDING: 'pending',
    SELF_SERVICE: 'self_service',
};
